var i18n = {
  'en-US': {
    'inspector.selector': 'Selector',
    'inspector.basicType': 'Type',
    'inspector.basicTypeValue': 'Basic Style',
    'inspector.boxSize': 'Outer frame size',
    'inspector.fontSize': 'Font size',
    'inspector.color': 'Color',
    'inspector.backgroundColor': 'Background color',
    'inspector.wcag': 'WCAG',
    'inspector.pass': 'Pass',
    'inspector.notPass': 'Not Pass'
  },
  'zh-CN': {
    'inspector.selector': '选择器',
    'inspector.basicType': '类型',
    'inspector.basicTypeValue': '基础样式',
    'inspector.boxSize': '外框尺寸',
    'inspector.fontSize': '字号',
    'inspector.color': '色值',
    'inspector.backgroundColor': '背景色',
    'inspector.wcag': '颜色对比度测试',
    'inspector.pass': '通过',
    'inspector.notPass': '未通过'
  }
};
export default i18n;